import React, {Component} from 'react'
import s from './TrustPilot.module.css'
import { Container } from '@components/ui'
import Image from "next/legacy/image"

export interface TrustPilotProps {
  href: string
  image?: any
}

const TrustPilot: React.FC<TrustPilotProps> = ((props) => {
  const {
    href,
    image
  } = props

  return (
    <div className={s.root}>
      <Container>
        <a className={s.link} href={href} target="_blank" rel="noreferrer">
          <Image alt="icon" src={image} layout="responsive"  width="127" height="68" />
        </a>
      </Container>
    </div>
  )
})

export default TrustPilot
